import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import {AmorgRoutes} from './AmorgRoutes';
import { GlobalStyle } from './globalStyles';


// Modal.setAppElement('#root');

export const redirectOnError = false;
export const redirectOnInsufficientPermission = true;

ReactDOM.render(
	<>
	<GlobalStyle />
	<BrowserRouter>
		<AmorgRoutes />
	</BrowserRouter>
	</>,
	document.getElementById("root")
);